var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9993 0.666748C11.6457 0.666748 11.3066 0.807223 11.0565 1.05727C10.8065 1.30732 10.666 1.64646 10.666 2.00008V5.66675H6.99935C6.64573 5.66675 6.30659 5.80722 6.05654 6.05727C5.80649 6.30732 5.66601 6.64646 5.66601 7.00008V11.5001H1.99935C1.64573 11.5001 1.30659 11.6406 1.05654 11.8906C0.806491 12.1407 0.666016 12.4798 0.666016 12.8334V16.0001C0.666016 16.3537 0.806491 16.6928 1.05654 16.9429C1.30659 17.1929 1.64573 17.3334 1.99935 17.3334H15.9993C16.353 17.3334 16.6921 17.1929 16.9422 16.9429C17.1922 16.6928 17.3327 16.3537 17.3327 16.0001V2.00008C17.3327 1.64646 17.1922 1.30732 16.9422 1.05727C16.6921 0.807223 16.353 0.666748 15.9993 0.666748H11.9993ZM7.33268 7.33341H10.666V15.6667H7.33268V7.33341ZM15.666 15.6667H12.3327V2.33341H15.666V15.6667ZM5.66601 13.1667V15.6667H2.33268V13.1667H5.66601Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.95f224dd31d48dea1444533437d11913.svg";
export { ForwardRef as ReactComponent };